import type { StyleProp, TextStyle } from 'react-native';

import { Text } from 'app/design/primitives/text';
import { useRef, useState } from 'react';
import { Pressable, TextInput, View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

interface AutomaticMessageInputProps {
  assistantMessageDefault?: string;
  inputStyle?: StyleProp<TextStyle>;
  onChangeText: (text: string) => void;
  onReset?: () => void;
  resetLabel?: string;
  value?: string | null;
}

export function MultiLineTextInput({
  assistantMessageDefault,
  inputStyle,
  onChangeText: onChangeTextProp,
  onReset,
  resetLabel,
  value,
}: AutomaticMessageInputProps) {
  const [isFocused, setIsFocused] = useState(false);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const inputRef = useRef<TextInput>(null);
  const isModified = onReset !== undefined && hasUserInteracted && value !== null && value !== assistantMessageDefault;
  return (
    <View style={{ borderRadius: 16 }}>
      <TextInput
        ref={inputRef}
        multiline
        value={value ?? assistantMessageDefault}
        onChangeText={(text) => {
          setHasUserInteracted(true);
          onChangeTextProp(text);
        }}
        selectTextOnFocus
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        scrollEnabled={isFocused}
        style={[
          {
            minHeight: 172,
            maxHeight: 200,
            fontSize: 14,
            lineHeight: 20,
            color: '#222',
            backgroundColor: theme.colors['surface.default'],
            borderRadius: 16,
            padding: 16,
            paddingTop: 16,
            paddingRight: 16,
            paddingBottom: isModified ? 46 : 16,
            borderWidth: 1,
            borderColor: isFocused ? theme.colors['text.primary'] : theme.colors['surface.tertiary-neutral'],
          },
          inputStyle,
        ]}
        editable
      />
      {!isFocused && (
        <Pressable
          onPress={() => inputRef.current?.focus()}
          style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}
        />
      )}
      {isModified ? (
        <Pressable
          onPress={onReset}
          hitSlop={8}
          style={({ pressed }) => ({
            position: 'absolute',
            bottom: 14,
            right: 16,
            opacity: pressed ? 0.6 : 1,
            alignItems: 'center',
            justifyContent: 'center',
          })}
        >
          <Text
            fontSize={13}
            style={{ color: theme.colors['text.brand'], fontWeight: '700', textDecorationLine: 'underline' }}
          >
            {resetLabel}
          </Text>
        </Pressable>
      ) : null}
    </View>
  );
}
